export type GlobalErrorSource = 'api_error' | 'window_error' | 'unhandled_rejection';

export interface GlobalErrorInput {
  source: GlobalErrorSource;
  message: string;
  details?: string;
  statusCode?: number;
}

type GlobalErrorReporter = (input: GlobalErrorInput) => void;

let reporter: GlobalErrorReporter | null = null;

export function setGlobalErrorReporter(nextReporter: GlobalErrorReporter | null) {
  reporter = nextReporter;
}

export function reportGlobalError(input: GlobalErrorInput) {
  try {
    reporter?.(input);
  } catch {
    // Never let error reporting throw
  }
}
